export default {
  'practice-in-seeing-3': {
    'course-title': '4C-2 Lecture',
    'course-name': '4C-Part 2 Lecture <span class="unit-title">Practice In Seeing 2<span>',
    'unit-section-title': '4C-2 <br> Optional Exercises in Applying SCQ',
    'video-title': `
      Section 4 BUILDING A PYRAMID<br>
      1’37:17 – 1’38:06 4D APPLYING THE SCQ PROCESS (MASTER CLASS) :- <br>
      ex 4D master class in applying SCQ - 1’38:26 – 1’47:11 <br>
      Applying SCQ practice exercises<br>
    `,
    'exercise-intro': `
    <p>You should now be fairly proficient in working out your thinking via the introduction in relatively simple documents. But you might find it useful to have a bit more practice.</p>
    <br/>
    <p>Here are several common, everyday kinds of business memos. Each memorandum contains information from which the pyramid shown with it was developed. The introduction has been left blank, but I have supplied the basic S C Q pattern into which it falls. Can you type in roughly what the Situation and Complication should say in each example?</p>
    <br/>`,
    'menu-list': {
      'exercise-1': 'Purchasing at Orlando',
      'exercise-2': 'Data Center Relocation',
      'exercise-3': 'PAGAM Property Disposal',
      'exercise-4': 'Domestic Bank’s Systems Strategy'
    },
    'exercise-1': {
      'number': '4C-2 - Exercise 1',
      'title': 'Purchasing at Orlando',
      'description': `Orlando is a large manufacturing company with several divisions. Presume you have been asked by the chief operating officer how to go about making sure that they do business only with qualified suppliers. Orlando has no centralized purchasing function, nor has it ever developed a formal supplier evaluation or qualification process consistently used throughout the organization. Each division makes its own decisions on who should supply its particular products and services, to the tune of $600 million every year. The amount covers a wide variety of materials from hundreds of different suppliers, selected by people at all levels in the company.
<br/><br/>The chief operating officer believes that many suppliers have come to the point where they consider selling to Orlando to be their right, rather than a hard won privilege. He believes the company needs a formalized and integrated process of supplier evaluation, qualification, and development that will support the achievement of Orlando’s procurement strategies.
<br/><br/>You have developed the appropriate process, and are ready to write a memo from COO to go to the rest of the organization. You have worked out the pyramid shown below. Type in roughly what the Situation and Complication should say.`
    },
    'exercise-2': {
      'number': '4C-2 - Exercise 2',
      'title': 'Data Center Relocation - First Commerce Bank',
      'description': `First Commerce Bank, located in New York City, has a Data Center in Princeton, New Jersey. First Commerce is taking aggressive steps to grow, having set its sights on becoming a Global Bank. There is considerable cost involved in going after all this growth, and the Bank appears to have decided that one way to save a bit would be to close the Princeton Data Center and move the IT activities to its offices at 101 Park Avenue. The move fits in with a general desire to centralize activities, in the interest of efficiency. FCB hired a consulting firm (The St. Hobart’s Group) to put together its relocation plan, which estimates that the cost to move would be no more than $33-45 million. The estimate is based on both FCB’s requirements and similar Data Relocation scenarios.
      <br/><br/>The Data Center team in NJ is, of course, appalled at this thinking, and believes the Bank is making a series of wrong assumptions. It has put together a list of these assumptions and the considerations the company is overlooking.
      `,
      'note': '',
      'description-2': `The team has decided to write to management and point out that their thinking may be based on three false assumptions, as shown on the following pyramid.`
    },
    'exercise-3': {
      'number': '4C-2 - Exercise 3',
      'title': 'PAGAM Property Disposal',
      'description': `
        <span>
            <span class="memo-paper__header">
                <p>TO:</p>
                <p>DATE:</p>
            </span>
            <span class="memo-paper__header">
                <p>FROM:</p>
                <p>SUBJECT: Accounting treatment for PAGAM Property Disposal</p>
            </span>
        </span>
        <br>
        <p><b>Background</b></p>
        <br>
        <p>PAGAM manages 40 acres of property in Oklahoma. PAGAM is requesting approval to clean up environmental hazards
          and raze buildings that are now defunct. The buildings were assumed by PAGAM due to a debtor (Langley Trust)
          defaulting on a note of $2,655,000. The buildings were recorded at the fair market value of $2,655,000.</p>
        <br>
        <p><b>Issues</b></p>
        <p>Whether to expense or capitalize the costs of environmental cleanup. Regarding the disposal of the property that
          PAGAM owns, several issues need to be decided:</p>
        <ol>
          <li>Environmental preparation is legally mandatory due to the asbestos within the building.</li>
          <li>We will most likely take a loss on the sale of the property. The building was recorded at fair market value,
            but property values in Oklahoma have decreased over the years we have owned the property. No adjustments
            have ever been made regarding revaluing the land (do not think it can be — see Journal of Accountancy). </li>
          <li>Therefore, with regards to capitalizing vs. expensing the cost of environmental preparation of the land before
            selling it, I believe the appropriate accountability would be to expense the costs.</li>
        </ol>
        <br>
        <p><b>Premise: 90-8: Capitalization of Costs to Treat Environmental Contamination</b></p>
        <br>
        <p>
          The costs that may be capitalized must meet the following criteria:
          <ul class="bullet-list">
            <li>The costs are incurred in preparing for sale that property currently held for sale</li>
            <li>The costs are to improve the safety of property owned by the company</li>
            <li>The costs mitigate of preventing environmental contamination</li>
          </ul>
          Per Example No. 8: Air in Office Building Contaminated with Asbestos Fibers. The building is environmentally hazardous with
          regards to factory/office workers. Conclusion: Capitalization of cost to remove asbestos.
        </p>
        <br>
        <p><b>Materiality</b></p>
        <br>
        <p>The cost of the preparation to sell the building is approximately $350,000. The cost is material to the total financial
          position of the company (PAGAM). Therefore, capitalizing the preparation costs is advisable.</p>`
    },
    'exercise-4': {
      'number': '4C-2 - Exercise 4',
      'title': 'Domestic Bank’s Systems Strategy',
      'description': `
      This introduction to a discussion of an Australian domestic bank’s Systems Strategy contains information from which the pyramid
      shown below was developed.
      <div class="memo-paper">
      <div>
        <span>
            <span class="memo-paper__header">
                <p>TO:</p>
                <p>DATE:</p>
            </span>
            <span class="memo-paper__header">
                <p>FROM:</p>
                <p>SUBJECT: Domestic Bank’s Systems Strategy</p>
            </span>
        </span>
        <br>
        <p><b>1.1	OBJECTIVE</b></p>
        <br>
        <p>A key objective of the Domestic Bank’s Systems Strategy is to build flexible and integrated systems supporting
          customer service, cost reduction and the provision of timely and accurate management information. This will be
          achieved through a properly managed and coordinated effort that:</p>
        <p>
          <ul class="bullet-list">
            <li>builds on the Bank’s existing investment in technology</li>
            <li>uses best of breed products to obtain the best business benefits</li>
            <li>balances flexibility and efficiency in relation to business objectives</li>
          </ul>
          <br>
        </p>
        <p>In establishing this strategy it is necessary to address the question:</p>
        <p>
        <br>
          <ul>
            Why is the use of best of breed products better than the complete rebuilding or replacement of all core  systems with a
            single, technically integrated, comprehensive solution?
          </ul>
        </p>
        <br>
        <p><b>1.2 THIS PAPER </b></p>
        <br>
        <p>
          This paper sets out the answer to this question, through:
          <br>
          <ul class="bullet-list">
            <li>an explanation of each approach, single integrated solution and best of breed</li>
            <li>the advantages and disadvantages of each approach</li>
            <li>the reasons why best of breed is the correct strategy</li>
            <li>the major implementation issues</li>
          </ul>
        </p>
        </div>
      </div>
      `,
      'description-2': `
      <br/><br/>
      <p><b>Three Ways Of Showing The Results Of Analyzing Alternatives, Assuming Alternatives A, B, C:</b></p>
      <br>
      <p><b>1. Structure around the criteria</b></p>
      <br>
      <img class="image__center" src="/assets/images/4c-2-1.png" alt="">
      <br>
      <p><b>2. Limit comparison to a single criterion</b></p>
      <br>
      <img class="image__center" src="/assets/images/4c-2-2.png" alt="">
      <br>
      <p><b>3. Structure around the alternatives themselves</b></p>
      <br>
      <img class="image__center" src="/assets/images/4c-2-3.png" alt="">
      `
    },
    'congratulation-message': 'well done A THIRD TIME',
    'finish-section': 'You have completed Section 4C-2',
    'final-description': 'You know even better how to see the structure<br/> beneath the wording of an introduction',
    'next-course-button': 'proceed to section 5A',
    'dashboard-button': 'Main menu',
  }
}




// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c2/practiceInSeeing3/i18n/en.js